import { render, staticRenderFns } from "./CreateOnRoad.vue?vue&type=template&id=3835fe35&scoped=true"
import script from "./CreateOnRoad.vue?vue&type=script&lang=js"
export * from "./CreateOnRoad.vue?vue&type=script&lang=js"
import style0 from "./CreateOnRoad.vue?vue&type=style&index=0&id=3835fe35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835fe35",
  null
  
)

export default component.exports